import classNames from "classnames";
import type { JSXElementConstructor, ReactNode } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type CardProps<T extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>> =
  (T extends keyof JSX.IntrinsicElements
    ? JSX.IntrinsicElements[T]
    : {
        className?: string;
        onClick?: () => void;
        children?: ReactNode;
      }) & {
    as?: T;
    variant?: "rounded" | "square";
    innerClassName?: string;
    disabled?: boolean;
    active?: boolean;
    error?: boolean;
    disableHover?: boolean;
  };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Card = <T extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>>({
  // @ts-ignore
  as = "div",
  variant = "rounded",
  disabled,
  active,
  className,
  innerClassName,
  disableHover,
  error,
  ...rest
}: CardProps<T>) => {
  const cls = classNames(
    className,
    innerClassName,
    "scha__lc__card",
    `scha__lc__card--${variant}`,
    disabled && "scha__lc__card--disabled",
    active && "scha__lc__card--active",
    error && "scha__lc__card--error",
    rest.onClick && !disableHover && "scha__lc__card--has-hover",
  );

  const Tag = as;

  return (
    // @ts-ignore
    <Tag className={cls} {...rest} />
  );
};
